import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatTimeAgo } from "@/lib/utils-app";
import { Skeleton } from "@/components/ui/skeleton";
import { MessageCircle } from "lucide-react";

export function Conversations() {
  const { data: conversations, isLoading } = useQuery({
    queryKey: ["conversations"],
    queryFn: async () => (await api.get("/conversations")).data,
    refetchInterval: 10000,
  });

  return (
    <div className="px-4 sm:px-6 pt-6 sm:pt-10 space-y-4" data-testid="conversations-page">
      <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Chat</h1>

      {isLoading ? (
        <div className="space-y-3">{[1, 2].map((i) => <Skeleton key={i} className="h-20 rounded-3xl" />)}</div>
      ) : conversations?.length ? (
        <div className="grid gap-3 sm:grid-cols-2" data-testid="conversations-list">
          {conversations.map((c) => {
            const other = c.other_user_name || c.pro_name || c.client_name || "Utente";
            return (
              <Link key={c.id} to={`/chat/${c.id}`} data-testid={`conversation-${c.id}`}
                className="flex items-center gap-3 bg-white rounded-3xl border border-slate-100 shadow-sm p-4 hover:border-volt/40 transition-colors active:scale-[0.99]">
                <div className="w-12 h-12 rounded-2xl bg-volt-soft text-volt flex items-center justify-center font-heading font-bold text-lg shrink-0">
                  {other[0]?.toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <p className="font-semibold text-slate-900 truncate">{other}</p>
                    <span className="text-[11px] text-slate-400 shrink-0">{formatTimeAgo(c.updated_at || c.last_message_at)}</span>
                  </div>
                  <p className="text-sm text-slate-500 truncate">{c.last_message || c.request_title || "Conversazione"}</p>
                </div>
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 text-center space-y-2" data-testid="empty-conversations">
          <MessageCircle className="w-8 h-8 text-slate-300 mx-auto" />
          <p className="text-sm text-slate-500">Nessuna conversazione. Le chat si aprono quando ricevi o invii un'offerta.</p>
        </div>
      )}
    </div>
  );
}
